// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bg_bv","reviews__wrapper__list":"bg_d6","reviewSlider":"bg_d7"};